import React from "react";
import { Routes, Route } from "react-router-dom";

import NotFound from "../pages/not-found/not-found";
import FormLogin from "../pages/form_login/form_login";
import FormHomePage from "../pages/form_home_page/form_home_page";
// import WelcomeShow from "../pages/welcome_show/WelcomeShow";
import PrivateRouter from "./PrivateRouter";
import ConfirmDialog from "../pages/form_code_test/form_code_test";
import PageInfoProfile from "../pages/page_info_profile/page_info_profile";
import PageManagerProfileFix from "../pages/page_manager_profile_fix/page_manager_profile_fix";
import PageUpdateBankAccount from "../pages/page_update_bank/page_update_bank";
import PageManagerPrice from "../pages/page_manager_price/page_manager_price";
import PageWithDrawMoney from "../pages/page_withdraw_money/page_withdraw_money";
import PageComfirmBank from "../pages/page_confirm_bank/page_confirm_bank";
import ManagerTransaction from "../pages/manager_in_transaction/manager_in_transaction";
import PageManagerProduction from "../pages/page_manager_production/PageManagerProduction";
import PageSlideImages from "../pages/page_manager_slide_image/PageSlideImages";
import PageNotification from "../pages/page_manager_notification/PageSlideNotification";
import PageManagerProductionInHomePages from "../pages/page_manager_production_in_home_page/PageManagerProductionInHomePages";
import PageSlideImagesEndNow from "../pages/page_manager_slide_image_endnow/PageSlideImagesEndNow";
import PageChangePasswordAdmin from "../pages/page_change_password_admin/page_change_password_admin";
import PageCreateProduction from "../pages/page_create_production/page_create_production";
import PageEditProduction from "../pages/page_edit_production/page_edit_production";

export default function RoutesLinkApi() {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <PrivateRouter>
              <FormHomePage />
            </PrivateRouter>
          }
        />
        <Route path="/login" element={<FormLogin />} />
        <Route path="*" element={<NotFound />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRouter>
              <FormHomePage />
            </PrivateRouter>
          }
        />
        <Route
          path="/manager_profile"
          element={
            <PrivateRouter>
              <PageManagerProfileFix />
            </PrivateRouter>
          }
        />
        <Route
          path="/test_code"
          element={
            <PrivateRouter>
              <ConfirmDialog />
            </PrivateRouter>
          }
        />
        <Route
          path="/profile_guest/:id"
          element={
            <PrivateRouter>
              <PageInfoProfile />
            </PrivateRouter>
          }
        />
        <Route
          path="/page_update_bank/:id"
          element={
            <PrivateRouter>
              <PageUpdateBankAccount />
            </PrivateRouter>
          }
        />
        <Route
          path="/manager_price"
          element={
            <PrivateRouter>
              <PageManagerPrice />
            </PrivateRouter>
          }
        />
        <Route
          path="/withdraw_manager"
          element={
            <PrivateRouter>
              <PageWithDrawMoney />
            </PrivateRouter>
          }
        />
        <Route
          path="/id_withdraw/:id"
          element={
            <PrivateRouter>
              <PageComfirmBank />
            </PrivateRouter>
          }
        />
        <Route
          path="/manager_transaction"
          element={
            <PrivateRouter>
              <ManagerTransaction />
            </PrivateRouter>
          }
        />
        <Route
          path="/product_promotion"
          element={
            <PrivateRouter>
              <PageManagerProduction />
            </PrivateRouter>
          }
        />
        <Route
          path="/edit_production_shop/:id"
          element={
            <PrivateRouter>
              <PageEditProduction />
            </PrivateRouter>
          }
        />
        <Route
          path="/create_production_shop"
          element={
            <PrivateRouter>
              <PageCreateProduction />
            </PrivateRouter>
          }
        />
        <Route
          path="/manager_slide"
          element={
            <PrivateRouter>
              <PageSlideImages />
            </PrivateRouter>
          }
        />
        <Route
          path="/manager_notification_app"
          element={
            <PrivateRouter>
              <PageNotification />
            </PrivateRouter>
          }
        />
        <Route
          path="/product_promotion_list_home_page"
          element={
            <PrivateRouter>
              <PageManagerProductionInHomePages />
            </PrivateRouter>
          }
        />
        <Route
          path="/manager_slide_endnow"
          element={
            <PrivateRouter>
              <PageSlideImagesEndNow />
            </PrivateRouter>
          }
        />
        <Route
          path="/change_password_admin"
          element={
            <PrivateRouter>
              <PageChangePasswordAdmin />
            </PrivateRouter>
          }
        />
        {/* <Route
          path="/table"
          element={
            <PrivateRouter>
              <HomePage />
            </PrivateRouter>
          }
        />
        <Route
          path="/about"
          element={
            <PrivateRouter>
              <AboutPage />
            </PrivateRouter>
          }
        />
        <Route
          path="/about_in_params/:id"
          element={
            <PrivateRouter>
              <AboutInCode />
            </PrivateRouter>
          }
        />



        

        <Route
          path="/profile_guest/:id"
          element={
            <PrivateRouter>
              <PageInfoProfile />
            </PrivateRouter>
          }
        />
        
        

       

        

        <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </>
  );
}
